(function(){
'use strict';
const PACKS=[
  {label:'Pack of 1',qty:1,price:799,variantId:48226460893403,img:'https://cdn.shopify.com/s/files/1/0566/4840/1048/files/ctand_pack_1.jpg?v=1782928765'},
  {label:'Pack of 2',qty:2,price:1499,variantId:48226501329115,img:'https://cdn.shopify.com/s/files/1/0566/4840/1048/files/ctand_pack_2.jpg?v=1782928765',badge:'Popular'},
  {label:'Pack of 3',qty:3,price:2149,variantId:48226506899675,img:'https://cdn.shopify.com/s/files/1/0566/4840/1048/files/ctand_pack_3.jpg?v=1782928765'},
  {label:'Pack of 4',qty:4,price:2749,variantId:48226507751643,img:'https://cdn.shopify.com/s/files/1/0566/4840/1048/files/ctand_pack_4.jpg?v=1782928765'},
  {label:'Pack of 6',qty:6,price:3699,variantId:48226509750491,img:'https://cdn.shopify.com/s/files/1/0566/4840/1048/files/ctand_pack_6.jpg?v=1782928765'},
  {label:'Pack of 8',qty:8,price:4599,variantId:48226513289435,img:'https://cdn.shopify.com/s/files/1/0566/4840/1048/files/ctand_pack_8.jpg?v=1782928765',badge:'Best Value'}
];
/* Prices above are a FALLBACK only — #ct-live-prices, rendered by the page template from the
   real Shopify products, overrides them. Change prices in Shopify, not here (21.08.26). */
(function syncLivePrices(){
  try{
    var el=document.getElementById('ct-live-prices');
    if(!el) return;
    var byId={};
    JSON.parse(el.textContent||'[]').forEach(function(r){ byId[r.vid]=r; });
    PACKS.forEach(function(p){
      var r=byId[p.variantId];
      if(r&&r.price>0) p.price=r.price;
    });
  }catch(e){}
})();
const SIL_COLORS=[
  {name:'Black',variantId:47851440308443,hex:'#1a1a1a',price:120},
  {name:'Navy Blue',variantId:47851440341211,hex:'#1e3a5f',price:120},
  {name:'White',variantId:47851440373979,hex:'#f0f0f0',price:120,border:true},
  {name:'Baby Pink',variantId:47851440406747,hex:'#f4a7b9',price:120}
];
const COL_COLORS=[
  {name:'Black',variantId:48163991650523,hex:'#1a1a1a',price:120},
  {name:'Sky Blue',variantId:48164004004059,hex:'#87CEEB',price:120},
  {name:'White',variantId:48163991716059,hex:'#f0f0f0',price:149,border:true},
  {name:'Baby Pink',variantId:48163991748827,hex:'#f4a7b9',price:149}
];
const BAT_VID=47851464163547,BAT_PRICE=350;
const CAROUSEL_IMGS=[
  'https://cdn.shopify.com/s/files/1/0566/4840/1048/files/CustoTag_Android_1.jpg?v=1777965022',
  'https://cdn.shopify.com/s/files/1/0566/4840/1048/files/CustoTag_Android_3.jpg?v=1770361488',
  'https://cdn.shopify.com/s/files/1/0566/4840/1048/files/CustoTag_Android_8.jpg?v=1770361488',
  'https://cdn.shopify.com/s/files/1/0566/4840/1048/files/CustoTag_Android_5.jpg?v=1770361488',
  'https://cdn.shopify.com/s/files/1/0566/4840/1048/files/CustoTag_Android_4.jpg?v=1770361488',
  'https://cdn.shopify.com/s/files/1/0566/4840/1048/files/CustoTag_Android_9.jpg?v=1770361488'
];
let selectedPack=1;
let silQtys=[0,0,0,0];
let colQtys=[0,0,0,0];
let bat={on:false,qty:1};
let carouselIdx=0,carouselTimer;
const fmt=n=>'\u20B9'+n.toLocaleString('en-IN');
/* ceil, not round: per-tag must never read LOWER than the true figure or it
   overstates the deal (same principle as the floored discount rule). */
const perUnit=p=>Math.ceil(p.price/p.qty);

function buildPackPicker(id){
  const el=document.getElementById(id);
  if(!el)return;
  el.innerHTML=PACKS.map((p,i)=>`
    <div class="ct-pack-card${i===selectedPack?' selected':''}" data-i="${i}" role="button" tabindex="0">
      <div class="ct-pack-img-wrap">
        ${p.badge?`<span class="ct-pack-badge">${p.badge}</span>`:''}
        <img class="ct-pack-img" src="${p.img}" alt="${p.label}" loading="lazy">
      </div>
      <div class="ct-pack-info">
        <div class="ct-pack-name">${p.label}</div>
        <div class="ct-pack-price">${fmt(p.price)}</div>
        ${p.qty>1?`<div class="ct-pack-per">${fmt(perUnit(p))}/tag</div>`:''}
      </div>
    </div>
  `).join('');
  el.querySelectorAll('.ct-pack-card').forEach(c=>{
    const h=()=>{
      selectedPack=+c.dataset.i;
      document.querySelectorAll('.ct-packs .ct-pack-card').forEach(x=>x.classList.remove('selected'));
      c.classList.add('selected');
      updateTotal();
    };
    c.addEventListener('click',h);
    c.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' ')h();});
  });
}

function buildColorGrid(gridId,colors,qtysArr){
  const el=document.getElementById(gridId);
  if(!el)return;
  el.innerHTML=colors.map((c,i)=>`
    <div class="ct-color-row${qtysArr[i]>0?' active':''}" data-i="${i}">
      <div class="ct-color-dot" style="background:${c.hex}${c.border?';box-shadow:inset 0 0 0 1.5px #ccc':''}"></div>
      <span class="ct-color-name">${c.name}</span>
      <span class="ct-color-row-price">${fmt(c.price)}</span>
      <div class="ct-color-qty-wrap">
        <button class="ct-qty-btn ct-cminus" data-grid="${gridId}" data-i="${i}">&#8722;</button>
        <span class="ct-qty-val" id="${gridId}-v-${i}">${qtysArr[i]}</span>
        <button class="ct-qty-btn ct-cplus" data-grid="${gridId}" data-i="${i}">+</button>
      </div>
    </div>
  `).join('');
  el.querySelectorAll('.ct-cminus').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const i=+btn.dataset.i;
      if(qtysArr[i]>0){
        qtysArr[i]--;
        document.getElementById(`${gridId}-v-${i}`).textContent=qtysArr[i];
        btn.closest('.ct-color-row').classList.toggle('active',qtysArr[i]>0);
        updateTotal();
      }
    });
  });
  el.querySelectorAll('.ct-cplus').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const i=+btn.dataset.i;
      qtysArr[i]++;
      document.getElementById(`${gridId}-v-${i}`).textContent=qtysArr[i];
      btn.closest('.ct-color-row').classList.add('active');
      updateTotal();
    });
  });
}

function initCheck(id,state){
  const el=document.getElementById(id);
  if(!el)return;
  const toggle=()=>{
    state.on=!state.on;
    el.classList.toggle('checked',state.on);
    el.innerHTML=state.on?'<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="2,8 6,12 14,4"/></svg>':'';
    updateTotal();
  };
  el.addEventListener('click',toggle);
  el.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' ')toggle();});
}

function initQty(minId,plusId,valId,state){
  const m=document.getElementById(minId),p=document.getElementById(plusId),v=document.getElementById(valId);
  if(!m||!p||!v)return;
  m.addEventListener('click',()=>{if(state.qty>1){state.qty--;v.textContent=state.qty;updateTotal();}});
  p.addEventListener('click',()=>{state.qty++;v.textContent=state.qty;updateTotal();});
}

function updateTotal(){
  let total=PACKS[selectedPack].price;
  let rows=`<div class="ct-order-row"><span>${PACKS[selectedPack].label}</span><span>${fmt(PACKS[selectedPack].price)}</span></div>`;
  SIL_COLORS.forEach((c,i)=>{
    if(silQtys[i]>0){const t=c.price*silQtys[i];total+=t;rows+=`<div class="ct-order-row"><span>Silicone Case \u2013 ${c.name} \xd7${silQtys[i]}</span><span>${fmt(t)}</span></div>`;}
  });
  COL_COLORS.forEach((c,i)=>{
    if(colQtys[i]>0){const t=c.price*colQtys[i];total+=t;rows+=`<div class="ct-order-row"><span>Collar Case \u2013 ${c.name} \xd7${colQtys[i]}</span><span>${fmt(t)}</span></div>`;}
  });
  if(bat.on){const t=BAT_PRICE*bat.qty;total+=t;rows+=`<div class="ct-order-row"><span>Battery Subscription \xd7${bat.qty}</span><span>${fmt(t)}</span></div>`;}
  rows+=`<div class="ct-order-row total"><span>Total</span><span>${fmt(total)}</span></div>`;
  document.querySelectorAll('.ct-order-summary').forEach(el=>el.innerHTML=rows);
  const sLabel=document.getElementById('ct-sticky-atc-label');
  const sPrice=document.getElementById('ct-sticky-atc-price');
  if(sLabel)sLabel.textContent=PACKS[selectedPack].label;
  if(sPrice)sPrice.textContent=fmt(total);
}

function showToast(msg){
  let t=document.getElementById('ct-toast');
  if(!t){t=document.createElement('div');t.id='ct-toast';t.className='ct-toast';document.body.appendChild(t);}
  t.innerHTML=msg;t.classList.add('show');
  setTimeout(()=>t.classList.remove('show'),4500);
}

/* Open the theme's slide-out cart after an add.
   The 13-08-26 cart redesign put the drawer behind <modal-trigger target="CART">
   (assets/modal.js). The five selectors this used to look for — data-cart-toggle,
   data-drawer-toggle, #CartToggle, .js-cart-open, [aria-label="Cart"] — match NOTHING on
   the current theme, so the lookup returned null and the drawer silently never opened
   while the item went in fine. They stay only as a fallback.
   Second trap: modal-popup._initCart() fetches /cart ONCE at page load and caches the
   detached <main-cart> node, so it is stale the moment we add. Refresh it first —
   main-cart.update() calls its callback unconditionally, so it must be passed one. */
function openCartDrawer(){
  const mp=document.querySelector('modal-popup[enable-cart]');
  const cart=mp&&mp.cartContent;
  if(cart&&typeof cart.update==='function'){try{cart.update(function(){});}catch(e){}}
  const toggle=document.querySelector('modal-trigger[target="CART"]')
    ||document.querySelector('[data-cart-toggle],[data-drawer-toggle="cart"],#CartToggle,.js-cart-open,[aria-label="Cart"]');
  /* the trigger's own handler bails on a missing cartContent, so don't claim success */
  if(toggle&&cart){toggle.click();return true;}
  return false;
}

async function addToCart(){
  const btns=['ct-atc-btn','ct-sticky-atc-btn'].map(id=>document.getElementById(id)).filter(Boolean);
  if(!btns.length||btns[0].disabled)return;
  const origs=btns.map(b=>b.textContent);
  btns.forEach(b=>{b.disabled=true;b.textContent='Adding...';});
  const items=[{id:PACKS[selectedPack].variantId,quantity:1}];
  SIL_COLORS.forEach((c,i)=>{if(silQtys[i]>0)items.push({id:c.variantId,quantity:silQtys[i]});});
  COL_COLORS.forEach((c,i)=>{if(colQtys[i]>0)items.push({id:c.variantId,quantity:colQtys[i]});});
  if(bat.on)items.push({id:BAT_VID,quantity:bat.qty});
  try{
    const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
    if(!r.ok)throw new Error();
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('cart:added'));
    openCartDrawer();
    showToast('Added to cart! <a href="/cart">View Cart \u2192</a>');
  }catch(e){
    showToast('Something went wrong. Please try again.');
  }finally{
    btns.forEach((b,i)=>{b.disabled=false;b.textContent=origs[i];});
  }
}

function initFAQ(){
  document.querySelectorAll('.ct-faq-item').forEach(item=>{
    item.querySelector('.ct-faq-q')?.addEventListener('click',()=>{
      const open=item.classList.contains('open');
      document.querySelectorAll('.ct-faq-item.open').forEach(i=>i.classList.remove('open'));
      if(!open)item.classList.add('open');
    });
  });
}

function initModal(){
  const overlay=document.getElementById('ct-modal');
  const video=document.getElementById('ct-modal-video');
  document.querySelectorAll('[data-open-video]').forEach(b=>b.addEventListener('click',()=>{
    overlay?.classList.add('open');video?.play();
  }));
  document.getElementById('ct-modal-close')?.addEventListener('click',()=>{
    overlay?.classList.remove('open');if(video){video.pause();video.currentTime=0;}
  });
  overlay?.addEventListener('click',e=>{
    if(e.target===overlay){overlay.classList.remove('open');if(video){video.pause();video.currentTime=0;}}
  });
}

function goTo(i){
  carouselIdx=i;
  const track=document.getElementById('ct-carousel-track');
  if(track)track.style.transform=`translateX(-${i*100}%)`;
  document.querySelectorAll('.ct-carousel-dot').forEach((d,j)=>d.classList.toggle('active',j===i));
  clearInterval(carouselTimer);
  startAuto();
}
function startAuto(){carouselTimer=setInterval(()=>goTo((carouselIdx+1)%CAROUSEL_IMGS.length),3500);}
function initCarousel(){
  const track=document.getElementById('ct-carousel-track');
  const dotsEl=document.getElementById('ct-carousel-dots');
  if(!track||!dotsEl)return;
  track.innerHTML=CAROUSEL_IMGS.map((src,i)=>`<div class="ct-carousel-slide"><img src="${src}" alt="CustoTag for Android" class="ct-hero-img"${i===0?' loading="eager"':' loading="lazy"'}></div>`).join('');
  dotsEl.innerHTML=CAROUSEL_IMGS.map((_,i)=>`<button class="ct-carousel-dot${i===0?' active':''}" data-i="${i}" aria-label="Slide ${i+1}"></button>`).join('');
  dotsEl.querySelectorAll('.ct-carousel-dot').forEach(d=>d.addEventListener('click',()=>goTo(+d.dataset.i)));
  document.getElementById('ct-carousel-prev')?.addEventListener('click',()=>goTo((carouselIdx-1+CAROUSEL_IMGS.length)%CAROUSEL_IMGS.length));
  document.getElementById('ct-carousel-next')?.addEventListener('click',()=>goTo((carouselIdx+1)%CAROUSEL_IMGS.length));
  let startX=0;
  track.addEventListener('touchstart',e=>{startX=e.touches[0].clientX;},{passive:true});
  track.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-startX;if(Math.abs(dx)>40)goTo(dx<0?(carouselIdx+1)%CAROUSEL_IMGS.length:(carouselIdx-1+CAROUSEL_IMGS.length)%CAROUSEL_IMGS.length);});
  startAuto();
}

function revealReviews(){
  // Judge.me ships its review widget hidden behind an inline
  // <style>.jdgm-rev-widg{display:none}</style> that only its own JS removes once it
  // hydrates the widget. That hydration doesn't reliably fire on this custom page
  // template, leaving the reviews invisible. Strip the hiding <style> so the cached
  // reviews always show; Judge.me's script still upgrades the widget (with its Load
  // More for the full review set) if/when it runs.
  document.querySelectorAll('.ct-reviews-jdgm .jdgm-temp-hiding-style').forEach(el=>el.remove());
}

function init(){
  revealReviews();
  buildPackPicker('ct-pack-picker');
  buildColorGrid('ct-sil-grid',SIL_COLORS,silQtys);
  buildColorGrid('ct-col-grid',COL_COLORS,colQtys);
  initCheck('ct-bat-check',bat);
  initQty('ct-bat-minus','ct-bat-plus','ct-bat-qty',bat);
  document.getElementById('ct-atc-btn')?.addEventListener('click',addToCart);
  initFAQ();
  initModal();
  initCarousel();
  updateTotal();
  document.getElementById('ct-sticky-atc-btn')?.addEventListener('click',addToCart);
  const stickyBar=document.getElementById('ct-sticky-atc');
  const buySection=document.getElementById('ct-buy');
  if(stickyBar&&buySection){
    new IntersectionObserver(([e])=>{
      stickyBar.classList.toggle('hidden',e.isIntersecting);
    },{threshold:0.1}).observe(buySection);
  }
}
document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();
})();